import { CourierBusiness, MBEPackageTypeBusiness } from "./enumeration.model";

interface DualUseShipment {
  shipmentType?: string | null;
  courierId?: number | null;
  shipPackTypeId?: number | null;
  addressTo?: { macroareaName?: string | null } | null;
}

interface DualUseCountry {
  isGermany?: boolean;
  isAustria?: boolean;
  isSpain?: boolean;
  isUk?: boolean;
}

interface PaperlessDocumentType {
  id: number | string;
  description: string;
}

interface DualUseReplacement {
  attachedId: number;
  deleteId: number | null;
  paperlessDocumentIds: number[] | undefined;
}

const DUAL_USE_DOCUMENT_TYPE = "other document";

export function canGenerateDualUse(
  shipment: DualUseShipment,
  country: DualUseCountry
): boolean {
  if (
    country.isGermany ||
    country.isAustria ||
    country.isSpain ||
    country.isUk
  ) {
    return false;
  }
  const excludedPackTypes: number[] =
    shipment.courierId === CourierBusiness.FEDEX
      ? [MBEPackageTypeBusiness.MBE_ENVELOPE]
      : [
          MBEPackageTypeBusiness.MBE_ENVELOPE,
          MBEPackageTypeBusiness.MBE_DOCUMENTS
        ];
  return (
    !!shipment.courierId &&
    shipment.shipmentType === "EXPORT" &&
    !!shipment.addressTo &&
    shipment.addressTo.macroareaName === "WORLDWIDE" &&
    !excludedPackTypes.includes(Number(shipment.shipPackTypeId))
  );
}

// Type ids differ per tenant (Italy 14, France 40); the description is the same everywhere.
export function dualUseDocumentType<T extends PaperlessDocumentType>(
  types: T[] | null | undefined
): T | undefined {
  return (types || []).find(
    type =>
      !!type.description &&
      type.description.trim().toLowerCase() === DUAL_USE_DOCUMENT_TYPE
  );
}

export function dualUseFilename(now: Date): string {
  return ("Dual Use " + now.toString()).split(" GMT")[0] + ".pdf";
}

export function replaceDualUse(
  previousId: number | null,
  uploadedId: number,
  paperlessDocumentIds: number[] | undefined
): DualUseReplacement {
  return {
    attachedId: uploadedId,
    deleteId: previousId,
    paperlessDocumentIds:
      previousId !== null && paperlessDocumentIds
        ? paperlessDocumentIds.filter(id => id !== previousId)
        : paperlessDocumentIds
  };
}
